import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="nosotros" className="py-24 bg-laura-cream text-laura-dark" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-18">
            <span className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-19">
              Sobre Nosotros
            </span>
            <h2 className="text-4xl md:text-5xl font-playfair text-laura-wood mb-8 leading-tight" data-id="element-20">
              Bienvenidos a El Rincón de Laura
            </h2>

            <div className="space-y-6 text-lg text-laura-wood/80 font-light leading-relaxed" data-id="element-21">
              <p data-id="element-22">
                El Rincón de Laura es un restaurante asador con encanto situado
                en Villaconejos, a solo 50 minutos de Madrid. Un lugar con
                personalidad y ambiente acogedor donde disfrutar de gastronomía
                tradicional madrileña.
              </p>
              <p data-id="element-23">
                Nuestra cocina se inspira en las recetas de la Vega del Tajuña,
                Aranjuez y Chinchón, con productos frescos de la zona y
                elaboraciones caseras que mantienen viva la tradición culinaria
                de esta tierra.
              </p>
              <p data-id="element-24">
                Laura y su equipo te reciben con la calidez de siempre, para que
                cada visita sea una experiencia especial. Ven a descubrir por
                qué somos el destino favorito de quienes buscan una escapada
                gastronómica cerca de Madrid.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2 relative" data-id="element-25">
            <div className="absolute -inset-4 bg-laura-olive/20 rounded-lg transform translate-x-4 translate-y-4 -z-10" data-id="element-26" />
            <img src="https://cdn.magicpatterns.com/uploads/4o6UMAKuxdcPBdQQTKPVY2/unnamed.webp" alt="Platos asados y vino en El Rincón de Laura" className="w-full h-auto object-cover rounded-lg shadow-xl" data-id="element-27" />
          </motion.div>
        </div>
      </div>
    </section>;
}